import React, { useState, useRef, useEffect } from "react";
import { useUserIdentity } from "../contexts/UserIdentityContext";
import { UserIcon } from "@heroicons/react/24/outline";

const IdentificationModal: React.FC = () => {
  const { identifyUser } = useUserIdentity();
  const [userId, setUserId] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 100);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = userId.trim();

    if (!/^\d{2}$/.test(trimmed)) {
      setError("Voer een geldig 2-cijferig nummer in");
      return;
    }

    setLoading(true);
    setError("");

    const result = await identifyUser(trimmed);

    if (!result.success) {
      setError(result.error || "Identificatie mislukt");
      setLoading(false);
      setUserId("");
      setTimeout(() => inputRef.current?.focus(), 100);
    }
    // On success, the context updates and this modal will unmount
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-gray-900/60 backdrop-blur-sm">
      <div
        className="w-full max-w-sm mx-4 bg-white rounded-xl shadow-2xl border border-gray-200 p-8"
        onPointerDown={(e) => e.stopPropagation()}
      >
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="p-3 bg-primary-50 rounded-full">
            <UserIcon className="h-8 w-8 text-primary-600" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-xl font-bold text-gray-900 text-center mb-1">
          Wie ben je?
        </h2>
        <p className="text-sm text-gray-500 text-center mb-6">
          Voer je 2-cijferig personeelsnummer in om verder te gaan.
        </p>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              ref={inputRef}
              type="text"
              inputMode="numeric"
              maxLength={2}
              placeholder="00"
              value={userId}
              onChange={(e) => {
                // Only allow digits
                const val = e.target.value.replace(/\D/g, "");
                setUserId(val);
                setError("");
              }}
              className="block w-full text-center text-3xl font-bold tracking-[0.3em] border-2 border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all"
              autoComplete="off"
            />
            {error && (
              <p className="mt-2 text-sm font-medium text-red-600 text-center" role="alert">
                {error}
              </p>
            )}
          </div>

          <button
            type="submit"
            disabled={loading || userId.length < 2}
            className="w-full py-3 px-4 text-sm font-semibold text-white bg-primary-600 rounded-lg shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? "Controleren..." : "Aanmelden"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default IdentificationModal;
